<template>
  <div class="identityRetrieval">
    <header-item
      :title-array="titleArray"
      :is-show="headShow"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <div class="formClass">
      <!-- <button @click="active++">{{ active }}++</button>
      <button @click="active--">{{ active }}--</button> -->
      <!-- step 1 -->
      <van-form v-if="active === 1" class="identity-retrieval-one" @submit="onSubmit">
        <van-field
          v-model="formParams.name"
          style="border-radius: 16px 16px 0 0;"
          label="真实姓名"
          :rules="rules.nameRules"
          placeholder="请输入姓名"
        />
        <van-field
          v-model="formParams.idCard"
          label="身份证号码"
          :rules="rules.idRules"
          placeholder="请输入身份证号码"
        />
        <van-field
          v-model="formParams.phoneNum"
          label="手机号"
          :rules="rules.mobileRules"
          placeholder="请输入能联系到您的手机号"
        />
        <van-field
          v-model="formParams.phoneCode"
          style="border-radius: 0 0 16px 16px;"
          maxlength="6"
          label="短信验证码"
          :rules="rules.codeRules"
          placeholder="请输入验证码"
        >
          <template #button>
            <p v-if="!showTime" style="color: #616edf; cursor: pointer" @click="getCode">{{ timeMsg }}</p>
            <p v-else style="color: #878787; cursor: pointer">{{ codeTime }} S</p>
          </template>
        </van-field>
        <p style="padding: 0.2rem 0.4rem;width:7rem;color: #878787">
          *如果1分钟内没有收到验证码请重新获取
        </p>
        <div class="bottom">
          <van-button
            round
            block
            type="info"
            color="#616edf"
            native-type="submit"
            class="formClass_btn"
          >下一步</van-button>
        </div>
      </van-form>
      <!-- 查询结果 -->
      <div v-if="active === 2" class="identity-retrieval-two">
        <h5 v-if="!bindPhoneListHide.length">亲爱的玩家，您当前的身份证未绑定雷霆账号。</h5>
        <h5 v-else>{{ `亲爱的玩家，您当前的身份证绑定了${bindPhoneListHide.length}个雷霆账号：` }}</h5>
        <ul>
          <li>雷霆账号</li>
          <li v-for="(item, i) in bindPhoneListHide" :key="i">{{ item }}</li>
        </ul>
        <!-- <div v-if="bindPhoneListHide.length" class="bottom"> -->
        <div class="bottom">
          <van-button
            round
            block
            plain
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="getFaceUrl"
          >查看完整账号</van-button>
        </div>
        <!-- <div class="identity-retrieval-two__errortips">该身份证今日查询次数已达到上限，请明日再来</div> -->
        <div class="identity-retrieval-two__tips">
          <span>温馨提示：</span>
          <p>1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。</p>
          <p>2.若您已记起完整的账号，可以找回您的账号密码。</p>
        </div>
      </div>
      <!-- pc 人脸验证 -->
      <div v-if="!this.$isFlag && active === 3" class="identity-retrieval-three">
        <div class="identity-retrieval-three__title">请使用<span>个人支付宝</span>，进行扫码验证</div>
        <div class="identity-retrieval-three__qrcode">
          <canvas id="canvas" class="QR" />
          <!-- <p>此二维码有效时间：五分钟</p> -->
          <p><span>请勿将二维码转发给其他人，否则可能造成损失</span></p>
        </div>
        <!-- <div class="identity-retrieval-three__errortips">已超过每日人脸识别的次数限制</div>
        <div class="identity-retrieval-three__errortips">二维码已过期，点击刷新</div>
        <div class="identity-retrieval-three__errortips">检测认证次数已用完，请刷新二维码</div> -->
        <van-button
          round
          block
          type="info"
          color="#616edf"
          class="formClass_btn"
          @click="checkFace"
        >认证已完成</van-button>
      </div>
      <div v-if="active === 4" class="identity-retrieval-four">
        <!-- <h5>亲爱的玩家，您当前的身份证未绑定雷霆账号。</h5> -->
        <h5>{{ `亲爱的玩家，您当前的身份证绑定了${bindPhoneList.length}个雷霆账号：` }}</h5>
        <ul>
          <li>雷霆账号</li>
          <li v-for="(item, i) in bindPhoneList" :key="i">{{ item }}</li>
        </ul>
        <div class="bottom">
          <van-button
            round
            block
            plain
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="active = 1"
          >查看完整账号</van-button>
        </div>
        <!-- <div class="identity-retrieval-two__errortips">该身份证今日查询次数已达到上限，请明日再来</div> -->
        <div class="identity-retrieval-two__tips">
          <span>温馨提示：</span>
          <p>1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。</p>
          <p>2.若您已记起完整的账号，可以找回您的账号密码。</p>
        </div>
      </div>
      <!-- end -->
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import rules from '@/mixins/validator'
import sendCode from '@/mixins/sendCode'
import { ltCaptcha } from '@/utils/ltCaptcha'
import { throttle } from '@/utils/debounce.js'
import * as api from '@/api/account-self-manage/retrieval'
import headerItem from '@/views/accountCenter/common/header'
import { send_phone_code } from '@/api/account-self-manage/accountAppeal'

export default {
  name: 'IdentityRetrieval',
  components: {
    headerItem
  },
  mixins: [sendCode],
  props: {
    headShow: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      rules: rules,
      active: 1,
      bindInfo: {},
      formParams: {
        name: '',
        idCard: '',
        phoneNum: '',
        phoneCode: ''
      },
      currentIndex: 0,
      titleArray: ['通过绑定身份证找回', '首页', '账号管理中心', '忘记账号', '通过绑定身份证找回'],
      bindPhoneList: [],
      bindPhoneListHide: []
    }
  },
  created() {},
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.identityRetrieval').className = ['identityRetrieval identityRetrievalH5 accountCommonH5']
    } else {
      document.querySelector('.identityRetrieval').className = ['identityRetrieval identityRetrievalWeb accountCommonWeb']
    }
  },
  methods: {
    getCode() {
      ltCaptcha((captcha) => {
        send_phone_code({
          type: 'SELF_ACCOUNT_RETRIEVE',
          phoneNum: this.formParams.phoneNum,
          captcha
        }).then(res => {
          if (res.status == 0) {
            this.startTimer()
            this.$msg('短信发送成功', 'success')
          }
        })
      })
    },
    onSubmit: throttle(function() {
      let isFilled = false
      for (const key in this.formParams) {
        if (!this.formParams[key]) {
          isFilled = true
        }
      }
      if (isFilled) {
        this.$msg('必填参数不能为空')
        return
      }
      this.$loading.show()
      api.id_card_input(this.formParams).then((res) => {
        this.$loading.hide()
        if (res.status === 0) {
          this.active = 2
          this.bindPhoneListHide = res.data ? res.data : []
        }
      }, () => {
        this.$loading.hide()
      })
    }, 300),
    getFaceUrl: throttle(function() {
      this.$loading.show()
      api.get_face().then((res) => {
        this.$loading.hide()
        if (res.status === 0) {
          if (this.$isFlag) {
            // 移动端
            this.$store.dispatch('accountSelf/saveIdentityRetrievalUrl', res.data)
            this.$router.push('/accountCenter/accountSelf/idFaceResult')
          } else {
            this.active = 3
            this.$nextTick(() => {
              this.useqrcode(res.data)
            })
          }
        }
      }, () => {
        this.$loading.hide()
      })
    }, 300),
    checkFace: throttle(function() {
      api.check_face().then(res => {
        if (res.status === 0) {
          this.active = 4
          this.bindPhoneList = res.data ? res.data : []
        } else {
          // todo
        }
      })
    }, 300),
    useqrcode(url) {
      var canvas = document.getElementById('canvas')
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数
      QRCode.toCanvas(canvas, url, function(error) {
        if (error) {
          console.error(error)
        } else {
          console.log('success!')
        }
      })
    },
    navBarClick() {
      console.log('aa')
      if (this.currentIndex == 1) {
        this.currentIndex = 0
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
</style>
<style lang="stylus" scoped>

// h5
  .identityRetrievalH5 {
    font-size: 0.25rem;
    background: #f5f7fa;
    // position relative
    z-index 99

    .checkbox {
      margin: 0.3rem 0;
      position: relative;
    }
    .formClass {
      padding: 0.4rem;
      .identity-retrieval {
        &-one {
          .formClass_btn {
            // width: 3.12rem
            margin: 0.5rem 0;
          }
          span {
            font-size: 0.26rem;
          }
        }
        &-two,
        &-four {
          h5 {
            color: #5D5D5D
            font-size 0.28rem
            line-height 1.5
            text-align: center
          }
          ul {
            width: 100%
            padding: 0.32rem 0.4rem
            box-sizing: border-box
            li {
              width: 100%
              color: #5D5D5D
              font-size 0.26rem
              line-height 1.5
              text-align: center
              padding: 0.12rem 0
              box-sizing: border-box
            }
            li:nth-child(2n+1) {
              background-color #ECECEC
            }
          }
          .bottom {
            padding: 0.32rem 0.4rem
          }
          &__errortips {
            color: #FF3D3D
            font-size 0.26rem
            line-height 1.5
            text-align: center
          }
          &__tips {
            padding: 0.4rem 0 0
            span {
              color: #EB8D12
              display: block
              font-size 0.28rem
              line-height 2
            }
            p {
              color: #878787
              font-size 0.26rem
              line-height: 1.5
            }
          }
        }
      }
    }
  }

// web
  .identityRetrievalWeb {
    padding-bottom: .5rem;
    border-radius: 10px;
    background: #fff;
    font-size: 0.25rem;
    margin: 5%
    .checkbox {
      margin: 0.3rem 0;
      font-size: 0.28rem;
    }
    .formClass {
      margin: auto;
      // width: 40%;
    }
    .identity-retrieval {
      &-one {
        display: flex;
        flex-direction: column;
        align-items: center;

        ::v-deep .van-cell {
          font-size: 0.28rem;
          width: 8rem;
        }
        .bottom {
          width: 60%
          margin: 0 auto
          p {
            margin: 0.2rem;
          }
          .formClass_btn {
            margin: 0.5rem auto;
            width: 7.4rem;
          }
        }
      }
      &-two,
      &-four {
        h5 {
          color: #5D5D5D
          font-size 0.32rem
          line-height 1.5
          text-align: center
        }
        ul {
          width: 60%
          padding: 0.32rem 0.4rem
          box-sizing: border-box
          margin: 0 auto
          li {
            width: 100%
            color: #5D5D5D
            font-size 0.3rem
            line-height 1.5
            text-align: center
            padding: 0.24rem 0
            box-sizing: border-box
          }
          li:nth-child(2n+1) {
            background-color #ECECEC
          }
        }
        .bottom {
          width: 60%
          padding: 0.32rem 0.4rem
          box-sizing: border-box
          margin: 0 auto
        }
        &__errortips {
          color: #FF3D3D
          font-size 0.26rem
          line-height 1.5
          text-align: center
        }
        &__tips {
          padding: 0.4rem 0.8rem 0
          span {
            color: #EB8D12
            display: block
            font-size 0.28rem
            line-height 2
          }
          p {
            color: #878787
            font-size 0.26rem
            line-height: 1.5
          }
        }
      }
      &-three {
        &__title {
          color: #656565
          font-size 0.32rem
          line-height 2
          text-align: center
          padding-bottom: 0.24rem
          span {
            color: #12A7EB
          }
        }
        &__qrcode {
          display: flex
          justify-content: center
          align-items: center
          flex-wrap: wrap
          #canvas {
            width 3.76rem !important
            height: 3.76rem !important
            margin: 0 auto !important
          }
          p {
            width: 100%
            color: #5D5D5D
            font-size 0.32rem
            line-height 2.5
            text-align: center
            span {
              font-weight bold
            }
          }
        }
        .formClass_btn {
          width: 7.36rem
          margin: 0.44rem auto
        }
        &__errortips {
          color: #FF3D3D
          font-size 0.26rem
          line-height 1.5
          text-align: center
        }
      }
    }
  }
</style>
